import { useContext } from 'react';
import SwitchTestContext from '../context/SwitchTestContext';

const useDigitalData = () => {
  const {
    digitalData,
  } = useContext(SwitchTestContext);

  const getDigitalDataValue = (key) => {
    const switchValue = digitalData?.[key];
    return switchValue;
  };

  return { digitalData, getDigitalDataValue };
};

export default useDigitalData;
